import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const ContainerDropdown = styled.div`
    position: relative;
`;

export const Dropdown = styled.div`
    position: absolute;
    max-width: 151px;

    box-shadow: 0px 3px 6px ${(props) => props.theme.lightGrey40};

    padding: 8px 0;

    z-index: 10000;

    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.lightGrey40};
    border-radius: 8px;

    &[role='menu'] {
        visibility: hidden;
    }

    &[role='menu'].visible {
        visibility: visible;
    }
`;

export const Option = styled.div`
    padding: 8px 24px;

    font-size: ${theme.font.size14};
    color: ${(props) => props.theme.black};
    font: normal normal normal 14px/24px Oxygen;
    letter-spacing: 0;

    white-space: nowrap;
`;
